<template>
  <HeaderBlock msg="HeaderBlock" />
  <div class="page-wrapper">
    <div class="page-header d-print-none">
      <div class="container-xl">
        <div class="search-area mt-5">
          <div class="input-group search-controls">
            <input type="text" class="form-control" placeholder="Search FAQs…" v-model="keywords"
              autocomplete="off" @keyup.enter="search()">
            <button type="button" class="btn btn-icon" aria-label="Button" @click="search()">
              <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24"
                stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                <path d="M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0"></path>
                <path d="M21 21l-6 -6"></path>
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="page-body">
      <div class="container-xl">
        <div class="card search-content">
          <div class="card-body py-3" v-if="searching">...</div>
          <template v-else>
            <div class="search-group" v-if="searchResults.products.length">
              <h3>{{ $t('Products') }}</h3>
              <a class="search-item" v-for="item in searchResults.products" :key="item.id"
                :href="'/product/' + item.short_name.toLowerCase()">{{ item.name }}</a>
            </div>
            <div class="search-group" v-if="searchResults.manuals.length">
              <h3>{{ $t('UserManual') }}</h3>
              <a class="search-item" v-for="item in searchResults.manuals" :key="item.id"
                :href="'/user_manual/' + item.id">{{ item.title }}</a>
            </div>
            <div class="search-group" v-if="searchResults.faqs.length">
              <h3>{{ $t('Faqs') }}</h3>
              <a class="search-item" v-for="item in searchResults.faqs" :key="item.id"
                :href="getFaqUrl(item)">{{ getFaqTitle(item) }}</a>
            </div>
            <div class="card-body py-3" v-if="searched && !hasSearchResults">{{ $t('NoResults') }}</div>
          </template>
        </div>
      </div>
    </div>
  </div>
  <FooterBlock msg="FooterBlock" />
</template>

<script>
import HeaderBlock from '../../components/HeaderBlock.vue'
import FooterBlock from '../../components/FooterBlock.vue'
import { global } from '../../global.js'

export default {
  name: 'SearchPage',
  components: { HeaderBlock, FooterBlock },
  data() {
    return {
      keywords: "",
      searching: false,
      searched: false,
      searchResults: { products: [], manuals: [], faqs: [] },
    };
  },
  computed: {
    hasSearchResults: function () {
      return this.searchResults.products.length || this.searchResults.manuals.length || this.searchResults.faqs.length;
    },
  },
  methods: {
    getFaqTitle: function (item) {
      return this.$i18n.locale == "zh" ? item.title_zh : item.title;
    },
    getFaqUrl: function (item) {
      let productIds = [];
      try {
        productIds = JSON.parse(item.product_id);
      } catch {
        productIds = [item.product_id];
      }
      return '/faq/' + productIds[0] + '/' + item.id;
    },
    search: function () {
      const keywords = this.keywords.trim();
      if (!keywords) return;
      this.$router.replace({ path: '/search', query: { keywords: keywords } });
      this.searching = true;
      global.postData("help_center/search", { keywords: keywords }).then(data => {
        this.searching = false;
        this.searched = true;
        this.searchResults = data != null && data.code == 200
          ? data.body
          : { products: [], manuals: [], faqs: [] };
      });
    },
  },
  mounted() {
    this.keywords = this.$route.query.keywords || "";
    this.search();
  },
}
</script>

<style scoped>
.search-area,
.search-content {
  max-width: 760px;
  margin-right: auto;
  margin-left: auto;
}

.search-group {
  padding: 12px 16px;
}

.search-group + .search-group {
  border-top: 1px solid var(--tblr-border-color);
}

.search-group h3 {
  margin-bottom: 6px;
}

.search-item {
  display: block;
  padding: 6px 0;
}

@media (max-width: 767.98px) {
  .search-controls .form-control {
    font-size: 16px;
    height: 40px;
  }
}
</style>
